// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDDwSEZb973UKy-NlUo1xuA1Nnyzgu1SOI",
    authDomain: "fir-a6532.firebaseapp.com",
    projectId: "fir-a6532",
    storageBucket: "fir-a6532.appspot.com",
    messagingSenderId: "5805458048",
    appId: "1:5805458048:web:7136beb43ada61c6e3dc65",
    measurementId: "G-YZ6Y45HTJ6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default firebaseConfig;
